import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { ConsolidatedDataType } from '@/shared/types'

class RiskMapReportApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getReports(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/risk-maps/risk-map-list',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getReport(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/risk-maps/report',
      params: {
        report_id: reportId,
      },
    })
  }

  public saveReport(patientId: string) {
    // return this.axiosCall({
    //   method: 'post',
    //   url: '/api/web/admin/risk-maps/create',
    //   data: {
    //     patient_id: patientId,
    //   },
    // })
    return [
      {
        id: 1,
        createdAt: new Date(2023, 11, 12, 12, 0, 43, 143),
        probingDepth: 1,
        summaryIndex: 1,
        bleeding: 1,
        dna: false,
        smoking: false,
        caries: 1,
        filling: 1,
        extracted: 1,
        nextCleaning: 1,
        nextPeriodontology: 1,
        userId: 1,
        patientId: 1,
        reportId: 1,
        periodontologyId: 1,
      },
    ]
  }

  public updateReport(reportId: number, report) {
    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/risk-maps/update',
      data: {
        report_id: reportId,
        index: JSON.stringify(report),
      },
    })
  }

  public removeReport(reportId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/risk-maps/delete/${reportId}`,
    })
  }

  public saveConsolidatedAnalyze(
    reportId: number,
    consolidatedData: ConsolidatedDataType
  ) {
    const { smoking, diabetes } = consolidatedData

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/risk-maps/update',
      params: {
        report_id: reportId,
        smoking: Number(smoking),
        diabetes: Number(diabetes),
      },
    })
  }
}

export const riskMapReportApi = new RiskMapReportApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
